const pageNameDefault = [
  { id: 1, name: "Bed & Bath", page_default: "ReadyMadeProduct", name_fa: " خواب و حمام" },
  {
    id: 2,
    name: "Fabric By Meter",
    page_default: "ReadyMadeFabricItem",
    name_fa: "پارچه های متری",
  },
  { id: 3, name: "Hardware Bracket", page_default: "NecessaryOrdering", name_fa: "ملزومات" },
  { id: 4, name: "Hardware Finial", page_default: "NecessaryOrdering", name_fa: "ملزومات" },
  { id: 5, name: "Hardware Ring", page_default: "NecessaryOrdering", name_fa: "ملزومات" },
  { id: 6, name: "Hardware Rod", page_default: "NecessaryOrdering", name_fa: "ملزومات" },
  { id: 7, name: "Hardware Tieback", page_default: "NecessaryOrdering", name_fa: "ملزومات" },
  { id: 8, name: "Ready Made Drapery", page_default: "OneCurtain", name_fa: "پرده آماده" },
  {
    id: 9,
    name: "Ready Made Shade Double Roller",
    page_default: "ReadyMadeDraperyItem",
    name_fa: "شیدهای آماده دابل رولرشید",
  },
  {
    id: 10,
    name: "Ready Made Shade Roman",
    page_default: "ReadyMadeDraperyItem",
    name_fa: "شیدهای آماده رومن",
  },
  {
    id: 11,
    name: "Ready Made Shade Roller",
    page_default: "ReadyMadeDraperyItem",
    name_fa: "شیدهای آماده رولرشید",
  },
  {
    id: 12,
    name: "Ready Made Shade Zebra",
    page_default: "ReadyMadeDraperyItem",
    name_fa: "شیدهای آماده زبرا",
  },
  { id: 13, name: "Towels", page_default: "ReadyMadeTowel", name_fa: "حوله ها" },
];

export default pageNameDefault;
